function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import ColumnMarquee from "./columnMarquee";
var nowYear = new Date().getFullYear();
var yearsLeft = [{
  label: "1年以內",
  value: "y[]=".concat(nowYear - 1, "_").concat(nowYear)
}, {
  label: "3-5年",
  value: "y[]=".concat(nowYear - 5, "_").concat(nowYear - 3)
}, {
  label: "10年以上",
  value: "y[]=1970_".concat(nowYear - 10)
}];
var yearsRight = [{
  label: "1-3年",
  value: "y[]=".concat(nowYear - 3, "_").concat(nowYear - 1)
}, {
  label: "5-10年",
  value: "y[]=".concat(nowYear - 10, "_").concat(nowYear - 5)
}];
var priceLeft = [{
  label: "10萬以下",
  value: "price=0_100000"
}, {
  label: "25-35萬",
  value: "price=250000_350000"
}, {
  label: "50-100萬",
  value: "price=500000_1000000"
}];
var priceRight = [{
  label: "10-25萬",
  value: "price=100000_250000"
}, {
  label: "35-50萬",
  value: "price=350000_500000"
}, {
  label: "100萬以上",
  value: "price=1000000_100000000"
}];
var UsedcarPopover = function UsedcarPopover(_ref) {
  var www = _ref.www,
    auto = _ref.auto,
    dataSource = _ref.dataSource,
    ga = _ref.ga,
    ga4 = _ref.ga4,
    uuid = _ref.uuid;
  var usedCar = dataSource.usedCar,
    usedCarBrand = dataSource.usedCarBrand;
  var brandListLeft = usedCarBrand.brandList.filter(function (_, index) {
    return index % 2 === 0;
  });
  var brandListRight = usedCarBrand.brandList.filter(function (_, index) {
    return index % 2 !== 0;
  });
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    pagePlatform = _useState2[0],
    setPagePlatform = _useState2[1];
  useEffect(function () {
    var pageRoute = window === null || window === void 0 ? void 0 : window.page_route;
    if (pageRoute === "t8891:index_index") {
      setPagePlatform("t8891-index");
    } else if ((pageRoute === null || pageRoute === void 0 ? void 0 : pageRoute.indexOf("newCar")) !== -1) {
      setPagePlatform("newcar");
    } else {
      setPagePlatform("auto");
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-left border-right'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title'
  }, "\u5FEB\u901F\u5C0E\u822A"), /*#__PURE__*/React.createElement("ul", null, usedCar.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.name
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link,
      target: '_blank',
      onClick: function onClick() {
        ga(["导航", "中古车", item.name]);
      },
      rel: 'noreferrer'
    }, item.name));
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-middle'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title'
  }, "\u689D\u4EF6\u627E\u8ECA"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-middle-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-section'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-section-title'
  }, "\u71B1\u9580\u5EE0\u724C"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-section-list'
  }, /*#__PURE__*/React.createElement("ul", null, brandListLeft.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-section-li',
      key: item.id
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link,
      target: '_blank',
      onClick: function onClick() {
        ga(["导航", "中古车", "热门厂牌"]);
      },
      rel: 'noreferrer'
    }, item.enName));
  })), /*#__PURE__*/React.createElement("ul", null, brandListRight.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-section-li',
      key: item.id
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link,
      target: '_blank',
      onClick: function onClick() {
        ga(["导航", "中古车", "热门厂牌"]);
      },
      rel: 'noreferrer'
    }, item.enName));
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-section second'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-section-title'
  }, "\u8ECA\u9F61"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-section-list'
  }, /*#__PURE__*/React.createElement("ul", null, yearsLeft.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-section-li',
      key: item.value
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "?").concat(item.value),
      onClick: function onClick() {
        ga(["导航", "中古车", "车龄"]);
      },
      target: '_blank',
      rel: 'noreferrer'
    }, item.label));
  })), /*#__PURE__*/React.createElement("ul", null, yearsRight.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-section-li',
      key: item.value
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "?").concat(item.value),
      onClick: function onClick() {
        ga(["导航", "中古车", "车龄"]);
      },
      target: '_blank',
      rel: 'noreferrer'
    }, item.label));
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-section third'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-section-title'
  }, "\u50F9\u683C"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-section-list'
  }, /*#__PURE__*/React.createElement("ul", null, priceLeft.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-section-li',
      key: item.value
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "?").concat(item.value),
      onClick: function onClick() {
        ga(["导航", "中古车", "价格"]);
      },
      target: '_blank',
      rel: 'noreferrer'
    }, item.label));
  })), /*#__PURE__*/React.createElement("ul", null, priceRight.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-section-li',
      key: item.value
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "?").concat(item.value),
      onClick: function onClick() {
        ga(["导航", "中古车", "价格"]);
      },
      target: '_blank',
      rel: 'noreferrer'
    }, item.label));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-right'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title'
  }, "\u51FA\u552E\u4E2D\u53E4\u8ECA"), /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-right-content'
  }, "\u5DF2\u6709", /*#__PURE__*/React.createElement("span", {
    className: 'highlight'
  }, usedCarBrand.dealTotal.toLocaleString()), "\u8F1B\u4E2D\u53E4\u8ECA\u901A\u904E", /*#__PURE__*/React.createElement("span", {
    className: 'highlight'
  }, "8891"), "\u6210\u4EA4\uFF01"), /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-right-content'
  }, "\u6700\u5FEB", /*#__PURE__*/React.createElement("span", {
    className: 'highlight'
  }, usedCarBrand.dealFastDay), "\u5929\u5C31\u6210\u4EA4\uFF01"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-right-footer'
  }, /*#__PURE__*/React.createElement("a", {
    className: 'tc-top-nav-popover-right-link primary',
    href: "".concat(www, "/help-sell.html"),
    onClick: function onClick() {
      ga(["导航", "中古车", "我要卖车"]);
    },
    target: '_blank',
    rel: 'noreferrer'
  }, "\u8ECA\u5546\u8CE3\u8ECA"), /*#__PURE__*/React.createElement("a", {
    className: "tc-top-nav-popover-right-link tracking-".concat(pagePlatform, "-nav-user-sell-car"),
    href: "".concat(www, "/sell-spread.html?source=8891&entry=hp_hp-qn-pcs"),
    onClick: function onClick() {
      ga4("usedcarResource_clicked", {
        channel: "首頁",
        spm: "",
        page: "首頁",
        module: "快速導航",
        element: "入口",
        element_id: "個人賣車",
        next_spm: "2.46.70.91"
      });
    },
    target: '_blank',
    rel: 'noreferrer'
  }, "\u500B\u4EBA\u8CE3\u8ECA", /*#__PURE__*/React.createElement("div", {
    className: "extra-swiper-wrapper"
  }, /*#__PURE__*/React.createElement(ColumnMarquee, {
    scrollHeight: 20,
    loop: true,
    wrapperStyles: {
      width: "64px",
      overflow: "hidden"
    },
    uuid: uuid
  }, ["高價收車", "免費賣車"].map(function (item, inx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "item-box",
      key: inx,
      dangerouslySetInnerHTML: {
        __html: item
      }
    });
  })))))));
};
export default UsedcarPopover;